export const ACTION_RESET = 'FETCH_STORYCATE_RESET';
export const ACTION_REQUEST = 'FETCH_STORYCATE_REQUEST';
export const ACTION_SUCCESS = 'FETCH_STORYCATE_SUCCESS';
export const ACTION_ERROR = 'FETCH_STORYCATE_ERROR';
